/**
 * Utility functions for detecting and handling inline comments in CodeMirror
 * Comments in the claims editor are lines that start with #
 */

/**
 * Get all comment line ranges in the document
 * @param {EditorView} view - The CodeMirror editor view
 * @returns {Array<{from: number, to: number}>} Array of comment line ranges
 */
export function getCommentLineRanges(view) {
    const doc = view.state.doc;
    const commentRanges = [];
    
    for (let i = 1; i <= doc.lines; i++) {
        const line = doc.line(i);
        const lineText = line.text;
        
        // Check if line starts with # (allowing for leading whitespace)
        if (lineText.trimStart().startsWith('#')) {
            commentRanges.push({
                from: line.from,
                to: line.to
            });
        }
    }
    
    return commentRanges;
}

/**
 * Check if a position is within any comment range
 * @param {number} pos - Position to check
 * @param {Array<{from: number, to: number}>} commentRanges - Array of comment ranges
 * @returns {boolean} True if position is within a comment
 */
export function isInCommentRange(pos, commentRanges) {
    return commentRanges.some(range => pos >= range.from && pos <= range.to);
}

/**
 * Check if a range overlaps with any comment range
 * @param {number} from - Start position
 * @param {number} to - End position  
 * @param {Array<{from: number, to: number}>} commentRanges - Array of comment ranges
 * @returns {boolean} True if range overlaps with a comment
 */
export function overlapsCommentRange(from, to, commentRanges) {
    return commentRanges.some(range => 
        (from >= range.from && from <= range.to) ||  // Start is in comment
        (to >= range.from && to <= range.to) ||       // End is in comment
        (from <= range.from && to >= range.to)        // Range spans comment
    );
}